import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Wrapper, MealPhoto, Name} from '../Modal/modal.style';

export class PictureModal extends PureComponent {
  render() {
    const {closeModalCallback, data} = this.props;
    return (
      <Wrapper onClick={closeModalCallback}>
        <Name>{data.name}</Name>
        <MealPhoto
          src={data.url}
          alt={data.name}
        />
      </Wrapper>
    );
  }
}

PictureModal.propTypes = {
  closeModalCallback: PropTypes.func,
  data: PropTypes.object
};

export default PictureModal;



// WEBPACK FOOTER //
// ./components/ModalContent/PictureModal.js